const STORAGE_KEY="Yassu";
// get All workspaces
export const getAccounts = () => {
  const data = localStorage.getItem(STORAGE_KEY);
  return data ? JSON.parse(data) : [];
};

// save all workspaces
export const saveAccounts = (accounts) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(accounts));
};

// delete workspace by id
export const deleteAccount = (id) => {
  const accounts = getAccounts();
  const updated = accounts.filter((acc) => acc.id !== id);
  saveAccounts(updated);
  removeWorkspaceData(id);
};

/* =========================
    keys for Workspace
   ========================= */
const keyResults = (wsId) => `${STORAGE_KEY}:ws:${wsId}:results`;
const keyForm    = (wsId) => `${STORAGE_KEY}:ws:${wsId}:form`;

/* =========================
    result Workspace
   ========================= */

// save results (array)
export const saveWorkspaceResults = (wsId, results) => {
  try {
    localStorage.setItem(keyResults(wsId), JSON.stringify(results ?? []));
    return true;
  } catch (e) {
    console.error("saveWorkspaceResults failed", wsId, e);
    return false;
  }
};

// get results
export const getWorkspaceResults = (wsId, fallback = []) => {
  try {
    const raw = localStorage.getItem(keyResults(wsId));
    return raw ? JSON.parse(raw) : fallback;
  } catch (e) {
    console.error("getWorkspaceResults failed", wsId, e);
    return fallback;
  }
};

/* =========================
   Workspace form status
   ========================= */
// save form state (object)
export const saveWorkspaceForm = (wsId, formState) => {
  try {
    localStorage.setItem(keyForm(wsId), JSON.stringify(formState ?? {}));
    return true;
  } catch (e) {
    console.error("saveWorkspaceForm failed", wsId, e);
    return false;
  }
};

// get form state
export const getWorkspaceForm = (wsId, fallback = {}) => {
  try {
    const raw = localStorage.getItem(keyForm(wsId));
    return raw ? JSON.parse(raw) : fallback;
  } catch (e) {
    console.error("getWorkspaceForm failed", wsId, e);
    return fallback;
  }
};

/* =========================
   Helpers: cleaning func 
   ========================= */
// delet form and result for Workspace 
export const removeWorkspaceData = (wsId) => {
  try {
    localStorage.removeItem(keyResults(wsId));
    localStorage.removeItem(keyForm(wsId));
  } catch (e) {
    console.error("remove Workspace Data failed", wsId, e);
  }
};

// Delete all storage Keys 
export const clearAllYassuData = () => {
  try {
    const toDelete = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith(STORAGE_KEY)) toDelete.push(k);
    }
    toDelete.forEach((k) => localStorage.removeItem(k));
  } catch (e) {
    console.error("clear All Data failed", e);
  }
};

/* =========================
   Prod Vitals Records
   ========================= */

const PROD_VITALS_KEY = "Yassu:prodVitalsRecords";

// Saves a new Prod Vitals analysis record, indexed by date and mailbox
export const saveProdVitalsRecord = (record) => {
  try {
    const allRecords = getProdVitalsRecords(); // Get all existing records
    
    const recordDate = new Date(record.timestamp).toISOString().split('T')[0]; // YYYY-MM-DD
    const mailboxKey = record.mailboxId;

    if (!allRecords[recordDate]) {
      allRecords[recordDate] = {};
    }
    if (!allRecords[recordDate][mailboxKey]) {
      allRecords[recordDate][mailboxKey] = [];
    }

    // Append new record to the specific date and mailbox
    allRecords[recordDate][mailboxKey].push(record);
    
    localStorage.setItem(PROD_VITALS_KEY, JSON.stringify(allRecords));
    return true;
  } catch (e) {
    console.error("saveProdVitalsRecord failed", e);
    return false;
  }
};

// Retrieves all Prod Vitals analysis records, now nested by date and mailbox
export const getProdVitalsRecords = () => {
  try {
    const raw = localStorage.getItem(PROD_VITALS_KEY);
    return raw ? JSON.parse(raw) : {}; // Return an object, not an array
  } catch (e) {
    console.error("getProdVitalsRecords failed", e);
    return {};
  }
};

// Clears all Prod Vitals analysis records
export const clearProdVitalsRecords = () => {
  try {
    localStorage.removeItem(PROD_VITALS_KEY);
    return true;
  } catch (e) {
    console.error("clearProdVitalsRecords failed", e);
    return false;
  }
};